import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { partnersCatalog } from '../orders-history/components/new-order/Models/neworder';
import { TranslationService } from '@core/services/common/translation.service';
import { MessageAlertService } from '@core/services/admin/common/messagealert.service';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/reducers';
import {
  selectCalendarsPartnerClonedByKey,
  selectCalendarsPartnerLoadingByKey,
} from 'src/app/store/calendars-partner/calendars-partner.selectors';
import { getCalendarsPartner as getCalendarsPartnerAction } from 'src/app/store/calendars-partner/calendars-partner.actions';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { PartnerResponseCommercial } from '../interfaces/partnerCommercial.interface';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';

@Injectable({
  providedIn: 'root',
})
export class PartnerCommercialService {
  private urlCalendars: string = '/Calendars';
  private urlPartnerCommercial: string = EndpointConstants.ApiPartnerOrder + this.urlCalendars;
  private options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };
  constructor(
    private http: HttpClient,
    protected messageAlertService: MessageAlertService,
    private _ts: TranslationService,
    private store: Store<AppState>,
  ) {}

  public getCalendarsPartner(
    countryCode: string,
    salesOrgCode: string,
    partnerCodes: string,
    cutOffTime: boolean = false,
  ): Observable<PartnerResponseCommercial> {
    const key = [countryCode, salesOrgCode, partnerCodes, cutOffTime].join('|');
    this.store.dispatch(
      getCalendarsPartnerAction({
        key,
        params: {
          countryCode,
          salesOrgCode,
          partnerCodes,
          cutOffTime,
        },
      }),
    );
    const cached$ = this.store.select(selectCalendarsPartnerClonedByKey(key));
    const loading$ = this.store.select(selectCalendarsPartnerLoadingByKey(key));

    return combineLatest([cached$, loading$]).pipe(
      filter(([cached, loading]) => cached !== null && loading === false),
      map(([cached]) => cached as PartnerResponseCommercial),
      take(1),
    );
  }

  /**
   * Llama directamente a la API de Calendars (usada por el effect)
   */
  public fetchCalendarsPartnerApi(
    countryCode: string,
    salesOrgCode: string,
    partnerCodes: string,
    cutOffTime: boolean = false,
  ): Observable<PartnerResponseCommercial> {
    return this.http.get<PartnerResponseCommercial>(
      `${this.urlPartnerCommercial}?countryCode=${countryCode}&salesOrgCode=${salesOrgCode}&partnerCodes=${partnerCodes}&cutOffTime=${cutOffTime.toString()}`,
      this.options,
    );
  }

  public getPartners(request: any) {
    return this.http
      .post<partnersCatalog>(
        environment.APIM + environment.newOrderAPI + '/Partners/GetPartnersCatalog',
        request,
        this.options,
      )
      .pipe(
        catchError((error) => {
          const errorMessage = this._ts.pt('views.errors.api-error.get-partner');
          console.error('Error fetching partners:', error);
          this.messageAlertService.notifyMessage({
            Type: 'error',
            Message: errorMessage,
          });
          throw error;
        }),
      );
  }

  public handleEmptyPartners(partners: partnersCatalog): void {
    let messageKey = '';
    if (partners.jobsites?.length === 0) {
      messageKey = 'views.errors.empty-data.order-taking.jobsite-list';
    } else if (!partners.pods?.length) {
      messageKey = 'views.errors.empty-data.order-taking.point-of-delivery-list';
    }
    if (!messageKey) {
      return;
    }
    this.messageAlertService.notifyMessage({
      Type: 'error',
      Message: this._ts.pt(messageKey),
    });
  }
}
